import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from 'angularfire2/database';
import { AuthService } from '../../service/auth.service';
import { Auth } from '../../service/auth';

@Component({
	selector: 'app-addition-worksheet',
	templateUrl: './addition-worksheet.component.html',
	styleUrls: ['./addition-worksheet.component.css']
})
export class AdditionWorksheetComponent implements OnInit {

	model: any = { 'theCheckbox': false };

	TimeList: Auth[];
	searchText;
	order: string = 'time';
	reverse: boolean = false;

	numberAddend: number;
	numberProblem: number;
	numberDigits: number;
	questions = [];
	list = [];
	list2 = [];
	list3 = [];
	resultval;
	resultList;
	sum;

	currentStudentToken;
	score: number;
	total: number;
	counter;
	allowcatedSeconds;
	seconds;
	interval;
	theCheckbox = false;
	color = [];
	submittedAnswers = false;
	answerSheet = false;
	resultSheet = false;
	progress;

	timeStarted = false;
	disappaer = false;
	worksheet = false;

	today = new Date();
	dd = String(this.today.getDate()).padStart(2, '0');
	mm = String(this.today.getMonth() + 1).padStart(2, '0');
	yyyy = this.today.getFullYear();

	constructor(public authService: AuthService,
		private db: AngularFireDatabase) { }

	ngOnInit() {
		this.score = 0;
		for (let i = 5; i <= 100; i += 5) {
			this.questions.push(i);
		}
		this.tokenStudentRegister();
		this.getTime();
	}

	tokenStudentRegister() {
		this.currentStudentToken = localStorage.getItem("currentStudentToken")
	}

	getTime() {
		const s = this.authService.getTimeList();
		s.snapshotChanges().subscribe(data => {
			this.TimeList = [];
			data.forEach(item => {
				const a = item.payload.toJSON();
				a['$key'] = item.key;
				this.TimeList.push(a as Auth);

			});
		});
	}

	randomIntFromInterval(min, numberDigits) {
		return Math.floor(Math.random() * (numberDigits - min + 1) + min);
	}

	continue() {
		var hms = this.model.counter;
		var a = hms.split(':');
		this.allowcatedSeconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
		this.seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);

		if (this.model.theCheckbox === false) {
			this.interval = setInterval(() => {
				this.seconds--;
				if (this.seconds > 0) {
					this.timeStarted = true;
					if (this.seconds === 0) {
						this.disappaer = true;
					}
				}
			}, 1000)
		} else {
			this.interval = setInterval(() => {
				if (this.seconds > 0) {
					this.timeStarted = true;
					this.seconds--;
					if (this.seconds === 0) {
						this.disappaer = true;
						clearInterval(this.interval);
						this.onSubmit();
					}
				}
			}, 1000);
		}
		this.worksheet = true;
		window.scroll(0, 0);
		const length = Number(this.model.numberProblem);

		this.resultval = new Array(length);
		this.resultList = new Array(length);
		this.sum = new Array(length);

		for (let i = 0; i < length; i++) {
			this.resultval[i] = new Array(length);
			this.resultList[i] = new Array(length);
			this.sum[i] = new Array(length);
		}

		for (let i = 0; i < this.model.numberProblem; i++) {
			this.list.push(i);
		}

		for (let i = 0; i < this.model.numberAddend; i++) {
			this.list2.push(i);
		}

		for (let i = 0; i < 1; i++) {
			this.list3.push(i);
		}

		for (let i = 0; i < this.model.numberProblem; i++) {
			for (let j = 0; j < this.model.numberAddend; j++) {
				const k = this.randomIntFromInterval(0, this.model.numberDigits);
				this.resultval[i][j] = k;
			}
		}
		this.total = this.model.numberProblem;
	}

	onSubmit() {
		this.submittedAnswers = true;
		window.scroll(0, 0);
		this.pauseTimer();
		for (let i = 0; i < this.model.numberProblem; i++) {
			let arrSum = 0;
			for (let k = 0; k < 1; k++) {
				this.resultval[i].forEach(element => {
					arrSum = arrSum + element;
				});
				if (arrSum == this.resultList[i][k]) {
					this.color[i] = 'green';
					this.score = this.score + 1;
				}
				if (this.resultList[i][k] != arrSum) {
					this.color[i] = 'red';
				}
				if (this.resultList[i][k] == undefined || this.resultList[i][k] == '') {
					this.resultList[i][k] = arrSum;
					this.color[i] = 'red';
				}
			}
		}
	}

	onProgress() {
		this.resultSheet = true;
		window.scroll(0, 0);
		this.addDatabase();
	}

	addDatabase() {
		this.progress = (this.score / this.total) * 100;
		this.db.list('student_quiz').push({
			userId: this.currentStudentToken,
			date: this.mm + '-' + this.dd + '-' + this.yyyy,
			operator: 'Addition',
			allocatedTime: this.allowcatedSeconds,
			consumeTime: this.allowcatedSeconds - this.seconds,
			totalQuiz: this.total,
			score: this.score,
			precentage: this.progress
		});
	}

	startTimer() {
		this.interval = setInterval(() => {
			this.seconds--;
			if (this.seconds > 0) {
				this.timeStarted = true;
				if (this.seconds === 0) {
					this.disappaer = true;
				}
			}
		}, 1000)
	}

	pauseTimer() {
		this.timeStarted = false;
		clearInterval(this.interval);
	}

}